module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayrainshowers@2-313611c648e2c10568c3f01f4ae45758.png";